import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface Toast {
  id: number;
  tone: 'ok' | 'danger';
  text: string;
}

export const useToasts = defineStore('toasts', () => {
  const items = ref<Toast[]>([]);
  let next = 1;

  function push(text: string, tone: Toast['tone'] = 'ok') {
    const id = next++;
    items.value.push({ id, tone, text });
    setTimeout(() => dismiss(id), tone === 'danger' ? 7000 : 4000);
  }

  function dismiss(id: number) {
    items.value = items.value.filter((t) => t.id !== id);
  }

  return { items, push, dismiss };
});
